// Prefissi telefonici internazionali usati dai form con numero di telefono
// (registrazione, profilo, recupero password). Il primo è il default: +39.
const countryCodes = [
  { code: '+39', country: 'Italia' },
  { code: '+33', country: 'Francia' },
  { code: '+49', country: 'Germania' },
  { code: '+34', country: 'Spagna' },
  { code: '+44', country: 'Regno Unito' },
  { code: '+41', country: 'Svizzera' },
  { code: '+43', country: 'Austria' },
  { code: '+32', country: 'Belgio' },
  { code: '+31', country: 'Paesi Bassi' },
  { code: '+351', country: 'Portogallo' },
  { code: '+30', country: 'Grecia' },
  { code: '+46', country: 'Svezia' },
  { code: '+47', country: 'Norvegia' },
  { code: '+45', country: 'Danimarca' },
  { code: '+358', country: 'Finlandia' },
  { code: '+353', country: 'Irlanda' },
  { code: '+1', country: 'USA/Canada' },
  { code: '+61', country: 'Australia' },
  { code: '+64', country: 'Nuova Zelanda' },
  { code: '+55', country: 'Brasile' },
  { code: '+52', country: 'Messico' },
  { code: '+54', country: 'Argentina' },
  { code: '+56', country: 'Cile' },
  { code: '+57', country: 'Colombia' },
  { code: '+51', country: 'Perù' },
  { code: '+7', country: 'Russia' },
  { code: '+86', country: 'Cina' },
  { code: '+81', country: 'Giappone' },
  { code: '+82', country: 'Corea del Sud' },
  { code: '+91', country: 'India' },
  { code: '+971', country: 'Emirati Arabi' },
  { code: '+966', country: 'Arabia Saudita' },
  { code: '+20', country: 'Egitto' },
  { code: '+27', country: 'Sudafrica' },
];

export const DEFAULT_COUNTRY_CODE = '+39';

export default countryCodes;
